import React from "react";
import "./index.css";

const Spinner = () => {
  return (
    <div className="spinner-container">
      <img src="/logo_small.png" alt="Logo" className="logo" />

      <div className="loader-line">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <p className="loading-text">Loading...</p>
    </div>
  );
};

export default Spinner;